module.exports = __webpack_public_path__ + "static/media/license.30b5e037.md";